export enum GlobalHiltiStoresRoutes {
  BASE = 'stores'
}
